import { connect } from 'react-redux';
import Signage from './signage';
import { loadOrders, loadLocation } from '../reducers/signage.reducers';

const mapStateToProps = state => ({
  orderGroups: state.signage.orderGroups,
  ordersPresent: state.signage.orderCount > 0,
  loggedIn: state.authentication.loggedIn,
  location: state.signage.location,
});

const mapDispatchToProps = dispatch => ({
  loadOrders: (locationId, cashboxIds, skipReschedule) => dispatch(loadOrders({ 
    locationId, 
    cashboxIds, 
    skipReschedule
  })),
  loadLocation: (locationId) => dispatch(loadLocation({ locationId }))
});


export default connect(mapStateToProps, mapDispatchToProps)(Signage);
